import { useState, useCallback } from "react";

export function useModalState<T>() {
    const [isOpen, setIsOpen] = useState(false);
    const [itemToEdit, setItemToEdit] = useState<T | null>(null);

    const handleOpenForAdd = useCallback(() => {
        setItemToEdit(null);
        setIsOpen(true);
    }, []);

    const handleOpenForEdit = useCallback((item: T) => {
        setItemToEdit(item);
        setIsOpen(true);
    }, []);

    const handleClose = useCallback(() => {
        setIsOpen(false);
        setItemToEdit(null);
    }, []);

    const isEditMode = itemToEdit !== null;

    return {
        isOpen,
        itemToEdit,
        isEditMode,
        handleOpenForAdd,
        handleOpenForEdit,
        handleClose,
    };
}
